import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';

const ThankYou = () => {
  useEffect(() => {
    // Load the form embed script
    const script = document.createElement('script');
    script.src = "https://calendrier.karinesilva.ca/js/form_embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="bg-[#FDF6F3] min-h-screen font-sans text-[#1A1A1A] selection:bg-[#5c8085] selection:text-white">
      <Navbar />
      
      <div className="pt-32 pb-20 px-6">
        <div className="container mx-auto max-w-3xl">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-12"
          >
            <h1 className="font-serif text-4xl md:text-5xl mb-6">Avant votre consultation</h1>
            <p className="text-lg text-gray-600 max-w-xl mx-auto">
              Avant votre consultation de 15-30 minutes, aidez-moi à personnaliser votre stratégie.
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="bg-white rounded-[20px] shadow-sm overflow-hidden"
            style={{ minHeight: '350px' }}
          >
            <iframe
                src="https://calendrier.karinesilva.ca/widget/form/tBCbfzNZkBqjCKAPz8Jj"
                style={{ width: '100%', height: '100%', border: 'none', borderRadius: '20px', minHeight: '350px' }}
                id="inline-tBCbfzNZkBqjCKAPz8Jj" 
                data-layout="{'id':'INLINE'}"
                data-trigger-type="alwaysShow"
                data-trigger-value=""
                data-activation-type="alwaysActivated"
                data-activation-value=""
                data-deactivation-type="neverDeactivate"
                data-deactivation-value=""
                data-form-name="Team Building - Qualification - suite"
                data-height="326"
                data-layout-iframe-id="inline-tBCbfzNZkBqjCKAPz8Jj"
                data-form-id="tBCbfzNZkBqjCKAPz8Jj"
                title="Team Building - Qualification - suite"
            >
            </iframe>
          </motion.div>
        </div>
      </div>
      
      {/* Simple Footer */}
      <footer className="py-8 text-center text-sm text-gray-400 font-medium uppercase tracking-widest">
        <p>© {new Date().getFullYear()} Karine Silva. Tous droits réservés.</p>
      </footer>
    </div>
  );
};

export default ThankYou;